import React, { ForwardedRef, forwardRef } from 'react';
import { GroupProps } from '@react-three/fiber/dist/declarations/src/three-types';
import VectorSphere from './VectorSphere';
import useDefaultValue from '../hooks/useDefaultValue';
import { Group } from 'three';
import { ThreeEvent } from '@react-three/fiber/dist/declarations/src/core/events';

type Props = GroupProps & {
    size?: number,
    outline?: number,
    color?: number,
    hideShading?: boolean,
    onClick?: (event:ThreeEvent<MouseEvent>) => void
};

const JokeSphere = forwardRef(({
  size,
  outline,
  color,
  children,
  hideShading,
  onClick,
  ...props
}: Props, ref?: ForwardedRef<Group>) =>
{
  const _size = useDefaultValue(size, 1);
  const _outline = useDefaultValue(outline, 0.006);

  return <group scale={[ _size, _size, _size ]} {...props} ref={ref}
    visible={props.visible && _size > 0.01} renderOrder={hideShading? -100: 0}>
    <VectorSphere outline={_outline} onClick={onClick} color={color} hideShading={hideShading}/>
    {children}
  </group>;
});

JokeSphere.displayName = 'JokeSphere';

export default JokeSphere;